import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CashReceiptForm from '../../components/pageModule/Cashreceipts/CashReceiptForm';
import { updateCashReceipt, fetchCashReceipt, setSelected, clearCurrentCashReceipt } from '../../store/modules/cashreceipt/cashreceiptActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const CashreceiptsEdit = () => {
    const cashreceiptState = useSelector(state => state.cashreceipt);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdate = async (formData) => {
        try {
            const response = await dispatch(updateCashReceipt(id, formData));
            toast.success('Cash receipt updated successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating cash receipt', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        fetchSingle: (id) => dispatch(fetchCashReceipt(id)),
        update: handleUpdate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentCashReceipt())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if(data) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, [actions]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <CashReceiptForm 
                                    initialData={cashreceiptState.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.update(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CashreceiptsEdit; 